/** Aggregate only supplied measures; missing source fields remain unavailable. */
export function summarizeAnalyticsRows(rows: Array<Record<string, unknown>>): Record<string, number | null> {
  const sum = (field: string): number | null => {
    if (!rows.length) return 0;
    if (rows.some(row => row[field] == null || !Number.isFinite(Number(row[field])))) return null;
    return rows.reduce((total, row) => total + Number(row[field]), 0);
  };
  const ratio = (a: number | null, b: number | null, multiplier = 1) => a == null || b == null || b <= 0 ? null : a / b * multiplier;
  const spend = sum('spend'), impressions = sum('impressions'), clicks = sum('clicks');
  const purchases = sum('purchases'), purchaseValue = sum('purchaseValue'), leads = sum('leads');
  return {
    spend, impressions, clicks, purchases, purchaseValue, leads,
    // Daily/per-ad reach overlaps. A period-level provider report is required.
    reach: null, frequency: null,
    ctr: ratio(clicks, impressions, 100), cpc: ratio(spend, clicks), cpm: ratio(spend, impressions, 1000),
    cpp: ratio(spend, purchases), roas: ratio(purchaseValue, spend), aov: ratio(purchaseValue, purchases),
    netAdProfit: spend == null || purchaseValue == null ? null : purchaseValue - spend,
    // Business-wide revenue and outbound/landing-page data are not in this report.
    mer: null, landingPageViews: null, outboundCtr: null,
    conversionRate: ratio(purchases, clicks, 100), addToCart: sum('addToCart'),
    checkoutInitiated: sum('initiateCheckout'), costPerLead: ratio(spend, leads),
    videoViews: sum('videoViews'), thumbstopRate: null, hookRate: null, holdRate: null,
    costPerThruplay: ratio(spend, sum('videoThruplay')),
    postEngagement: sum('engagements'), postReactions: sum('likes'), postShares: sum('shares'), postComments: sum('comments'),
  };
}
